import type { FC } from 'react';
import type { LinksFunction } from '@remix-run/node';
import clsx from 'clsx';

import {
  DbooRunScanForm,
  links as dbooRunScanForm,
} from '../dboo-run-scan-form/dboo-run-scan-form';

import type { DbooRunSectionProps } from './dboo-run-section.types';

import styles from './dboo-run-section.css?url';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
  ...dbooRunScanForm(),
];

export const DbooRunSection: FC<DbooRunSectionProps> = ({
  title,
  subtitle,
  actionLabel,
  className,
}) => {
  const classNames = clsx('dboo-run-section', className);

  return (
    <div className="container">
      <section className={classNames}>
        <h1 className="dboo-run-section__title">{title}</h1>
        <p className="dboo-run-section__subtitle">{subtitle}</p>
        <DbooRunScanForm actionLabel={actionLabel} />
      </section>
    </div>
  );
};
